export default __webpack_public_path__ + "assets/patentDrawing.5dc3cbca.png";